/**
 * counter
 */

import $ from "jquery";
import store, { eventBus } from "js/lib/Store";

export default {
  props: ["current-amount", "product-id", "update", "max"],
  data() {
    return {
      amount: this.currentAmount || 1,
      id: this.productId,
    };
  },
  methods: {
    validate() {
      this.amount =
        !this.isNumber(this.amount) || this.amount < 1
          ? 1
          : parseInt(this.amount);

      store.dispatch("getProduct", this.id).then(([product]) => {
        if (product) {
          store.dispatch("updateAmount", {
            id: this.id,
            amount: this.amount,
          });
        }
      });

      this.update({ amount: this.amount });
      this.$emit("change");
    },
    decrease() {
      this.amount--;
      this.validate();
    },
    increase() {
      if (this.amount < this.max) {
        this.amount++;
        this.validate();
      }
    },
    isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
  },
  template: `#counter-template`,

  mounted() {
    eventBus.$on("product.amount.change", ({ id, amount }) => {
      if (id === this.id) {
        this.amount = amount;
        this.update({ amount });
      }
    });
  },
};
